function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.303 17.3338V8.76339C43.3031 7.1497 42.6656 5.60134 41.5294 4.45546C40.3932 3.30958 38.8503 2.659 37.2366 2.64539H28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3337 2.64539H8.76336C7.14077 2.64539 5.58463 3.28996 4.43728 4.43731C3.28993 5.58466 2.64536 7.1408 2.64536 8.76339V17.3338",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.6534 43.303H37.2366C38.8414 43.2896 40.3765 42.6461 41.5113 41.5113C42.6461 40.3766 43.2895 38.8414 43.303 37.2367V28.6534",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.64536 28.6534V37.2367C2.65897 38.8503 3.30955 40.3932 4.45543 41.5294C5.60131 42.6656 7.14967 43.3031 8.76336 43.303H17.3337",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(14.1 14.1) scale(0.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4025 18.6998L20.7803 19.9023L21.7162 21.9127L24.2327 22.4764L24.8982 24.5056L27.9347 24.919L28.0803 22.3637L29.4113 21.086L28.309 18.2488L25.6053 19.1319L22.4025 18.6998Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeWidth: 1.23512,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5611 17.61L34.5492 10.8083L34.2788 11.5411L33.9668 4.7206C33.946 4.47634 34.0916 4.25087 34.3204 4.15692L41.9947 1.03792C42.4939 0.831235 42.8682 1.52643 42.3691 1.7519L34.8611 5.15275L35.2147 4.58907L36.3793 11.3344C36.4209 11.6162 36.317 11.8793 36.109 12.0672L29.121 18.8689C28.2267 19.7707 26.6668 18.4743 27.6027 17.5912L27.5611 17.61Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.7682 24.3553C28.7682 24.3553 33.9884 30.7624 34.0092 30.8C34.1756 30.9879 34.2172 31.2321 34.1756 31.4576L33.0941 36.5119L32.8861 35.9482L37.0457 40.4576C37.3368 40.7582 36.8377 41.1904 36.5257 40.9086L31.7839 36.8877C31.5967 36.7374 31.5551 36.5119 31.5759 36.3052L32.1166 31.1946L32.3038 31.8898L27.0836 25.4826C26.2933 24.4868 27.9363 23.3783 28.7682 24.3741V24.3553Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.948 20.8614L12.4635 17.322L13.2413 17.3957L8.27965 18.3359C8.00634 18.4096 7.66996 18.3359 7.52279 18.1331L4.5584 14.4646C4.45328 14.3355 4.49532 14.1512 4.64249 14.059C4.76863 13.9668 4.95785 13.9853 5.06297 14.0959L8.65809 17.322L7.90123 17.1192L12.6947 15.6444C12.968 15.5522 13.2413 15.6075 13.4726 15.7181L21 19.5C22 20 21.7194 22.0715 20.5 21.5L19.948 20.8614Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.1589 20L44.7308 22.3681C45.13 22.4253 45.0701 23.0365 44.6509 22.9983L29 22L29 19L30.1589 20Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.5655 18.1883L24.7319 9.43251C24.7319 9.03794 25.3974 9.01915 25.439 9.39493L26.6453 18.0755C26.8116 19.3908 24.5655 19.5035 24.5655 18.1695V18.1883Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.8137 22.7582L16.3253 24.4146C15.9301 24.5837 15.4631 24.1147 15.8374 23.9268L20.8778 21.086C22.1257 20.4283 23.1448 22.2321 21.8137 22.7582Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.8047 25.4248L20.9438 30.7271L21.0663 30.478L19.8001 34.7483C19.6979 35.1576 18.9423 35.033 19.0035 34.6238L19.6367 30.2467C19.6367 30.1399 19.6979 30.0688 19.7592 29.9976L24.1299 24.3928C24.9264 23.3964 26.6216 24.4995 25.7638 25.4426L25.8047 25.4248Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.1585 18.5558L18.0422 13.4192C17.8486 13.1219 18.3712 12.8411 18.6035 13.1054L22.7844 17.6639C23.6167 18.6053 21.8166 19.5963 21.1585 18.5558Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
}));
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 39.2889C14.9658 39.2889 17.3466 36.9081 17.3466 33.9711C17.3466 31.0342 14.9658 28.6534 12.0289 28.6534C9.09196 28.6534 6.71112 31.0342 6.71112 33.9711C6.71112 36.9081 9.09196 39.2889 12.0289 39.2889Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0289 36.3203C11.8406 36.3203 11.66 36.395 11.5269 36.5282C11.3938 36.6613 11.319 36.8419 11.319 37.0301C11.3054 37.1305 11.3134 37.2326 11.3425 37.3297C11.3716 37.4267 11.4211 37.5163 11.4878 37.5926C11.5544 37.6689 11.6366 37.7301 11.7288 37.772C11.821 37.8139 11.9211 37.8355 12.0224 37.8355C12.1237 37.8355 12.2238 37.8139 12.3161 37.772C12.4083 37.7301 12.4905 37.6689 12.5571 37.5926C12.6237 37.5163 12.6733 37.4267 12.7024 37.3297C12.7315 37.2326 12.7395 37.1305 12.7259 37.0301C12.7259 36.8441 12.6529 36.6655 12.5225 36.5327C12.3922 36.3999 12.2149 36.3236 12.0289 36.3203Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.3448 30.8734V34.5907C11.3448 34.7687 11.4155 34.9394 11.5414 35.0652C11.6672 35.1911 11.838 35.2618 12.016 35.2618C12.194 35.2618 12.3647 35.1911 12.4906 35.0652C12.6164 34.9394 12.6871 34.7687 12.6871 34.5907V30.8734C12.6871 30.6954 12.6164 30.5247 12.4906 30.3988C12.3647 30.2729 12.194 30.2022 12.016 30.2022C11.838 30.2022 11.6672 30.2729 11.5414 30.3988C11.4155 30.5247 11.3448 30.6954 11.3448 30.8734Z",
  fill: "#FF7A00",
  className: "color-error-stroke"
});
function SvgDamageTooFar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamageTooFar);
export default __webpack_public_path__ + "static/media/damage-too-far.aa410a4a3414dadd862578ed139fa9de.svg";
export { ForwardRef as ReactComponent };